import React from 'react';

import {
  NavigationItemInterface,
  SidebarNavigationItemInterface,
} from 'interfaces/navigationItem.interface';

import ExternalLinks from 'const/externalLinks';

import { ReactComponent as FolderIcon } from 'assets/icons/FolderTwoTone.svg';
import { ReactComponent as HomeIcon } from 'assets/icons/HomeTwoTone.svg';
import { ReactComponent as LeadsIcon } from 'assets/icons/Leads.svg';
import { ReactComponent as LineChartIcon } from 'assets/icons/LineChartOutlined.svg';
import { ReactComponent as UnorderedListIcon } from 'assets/icons/UnorderedListOutlined.svg';

/** Ordre et pictogrammes repris de la maquette « Refonte Plat. Primes ». */
export const getSidebarNavigationItems = (
  isLeadReferent: boolean,
  isLeadOnly: boolean,
): SidebarNavigationItemInterface[] => {
  const items: SidebarNavigationItemInterface[] = [
    {
      key: 'accueil',
      labelKey: 'navigation:accueil',
      path: '/',
      matchPaths: ['/'],
      icon: <HomeIcon />,
    },
  ];

  if (isLeadReferent) {
    items.push({
      key: 'gestion-leads',
      labelKey: 'navigation:gestion_leads',
      path: '/gestion-leads',
      matchPaths: ['/gestion-leads'],
      icon: <LeadsIcon />,
    });
  }

  if (!isLeadOnly) {
    items.push(
      {
        key: 'mes-simulations',
        labelKey: 'navigation:mes_simulations',
        path: '/simulations',
        matchPaths: ['/simulations'],
        icon: <UnorderedListIcon />,
      },
      {
        key: 'mes-dossiers',
        labelKey: 'navigation:mes_dossiers',
        path: '/dossiers',
        matchPaths: ['/dossiers'],
        icon: <FolderIcon />,
      },
      {
        key: 'tableau-de-bord',
        labelKey: 'navigation:tableau_de_bord',
        path: '/tableau-de-bord',
        matchPaths: ['/tableau-de-bord'],
        icon: <LineChartIcon />,
      },
    );
  }

  return items;
};

export const getBottomNavigationItems = (
  isLeadReferent: boolean,
  isLeadOnly: boolean,
): NavigationItemInterface[] => {
  const items: NavigationItemInterface[] = [
    {
      key: '/',
      label: 'Actualités',
    },
  ];

  if (isLeadReferent) {
    items.push({
      key: '/gestion-leads',
      label: 'Gestion de leads',
    });
  }

  if (!isLeadOnly) {
    items.push(
      {
        key: '/dossiers',
        label: 'Suivi de dossiers',
      },
      {
        key: '/simulations',
        label: 'Mes simulations',
      },
      // Absente du menu latéral, qui est figé à 5 entrées par la maquette : le
      // pied de page reste son unique point d'entrée.
      {
        key: '/generation-document',
        label: 'Générer un document',
      },
      {
        key: ExternalLinks.Reglementaire,
        label: 'Réglementation',
        target: '_blank',
      },
    );
  }

  items.push(
    // Idem : hors du menu latéral, accessible seulement depuis le pied de page.
    {
      key: '/faq',
      label: 'FAQ',
    },
    {
      key: ExternalLinks.MentionsLegales,
      label: 'Mentions légales',
      target: '_blank',
    },
    {
      key: ExternalLinks.Cgu,
      label: "Conditions générales d'utilisation",
      target: '_blank',
    },
    {
      key: ExternalLinks.PolitiqueConfidentialite,
      label: 'Politique de confidentialité',
      target: '_blank',
    },
  );

  return items;
};
